// sseClient.ts
import {EventSource} from 'eventsource';

let eventSourceInstance: EventSource | null = null;

let isConnect = false;

interface JobSSEConnection {
    eventSource: EventSource | null;
    isConnect: boolean;
}



export const getEventSource = (SSE_URL : string): JobSSEConnection => {


    const token = localStorage.getItem('token');

    if ((!eventSourceInstance || eventSourceInstance.readyState === 2) && token ) {
        // readyState 2 === CLOSED
        eventSourceInstance = eventSourceInstance = new EventSource(SSE_URL, {
            fetch: (input: any, init: any) =>
                fetch(input, {
                    ...init,
                    headers: {
                        ...init.headers,
                        Authorization: `Bearer ${token}`,
                    },
                }),
        })
        isConnect = false;
    } else {
        console.error("an instance of sse connection has already been instantiated");
        isConnect = true;
    }

    return { eventSource: eventSourceInstance, isConnect };
};

export const closeEventSource = (): void => {
    if (eventSourceInstance && eventSourceInstance.readyState !== 2) {
        eventSourceInstance.close();
        eventSourceInstance = null;
    }
};
